<n-dialog id="simple-mode-tip" class="simple-mode-tip" width="4.8rem"
    [visible]="visible" [closeBtn]="false" [type]="SWITCH.IS_SIMPLE_MODE ? 'simple-mode' : 'default'">
    <ng-template nTemplate="header">
        <!-- 高亮圆圈 -->
        <div #circle class="simple-mode-tip-circle"
            [ngStyle]="{'background-color': circleColor.backGround, 'color': circleColor.icon}">
            <!-- 极简/普通模式切换图标 -->
            <svg *ngIf="currentTip === SimpleModeTipE.SimpleModeSwitch" class="icon">
                <use xlink:href="#app-icon-mode-switch"></use>
            </svg>
            <!-- 智能助手图标 -->
            <svg *ngIf="currentTip === SimpleModeTipE.SmartAssistant" class="icon">
                <use xlink:href="#app-icon-smart-assistant-switch"></use>
            </svg>
        </div>
        <!-- CSS三角 -->
        <div #triangle class="simple-mode-tip-triangle"></div>
        <!-- 背景图 -->
        <div class="simple-mode-tip-background" [style.background-image]="backgroundImgUrl"></div>
        <!-- X按钮 -->
        <button nButton icon="icon-close" class="close-icon" [border]="false" (click)="hideTip()"></button>
    </ng-template>
    <!-- 文字 -->
    <div class="simple-mode-tip-text">
        <h2 class="title-md">{{tipTitle}}</h2>
        <span>{{tipContent}}</span>
    </div>
    <ng-template nTemplate="footer">
        <!-- 页数 -->
        <span class="sub">{{currentTip + "/" + tipsNum}}</span>
        <div>
            <!-- 下次不再显示 -->
            <button *ngIf="notShowBtnVisible"
                id="simple-mode-tip-not-show-btn"
                nButton
                [label]="i18n.notShowAgain"
                (click)="setNotShowAgain()">
            </button>
            <!-- 下一步/立即体验 -->
            <button id="simple-mode-tip-next-btn"
                nButton theme="primary"
                [label]="btnLabel"
                (click)="next()">
            </button>
        </div>
    </ng-template>
</n-dialog>
